import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "../../global/main.css";
import "./Skills.css";
import { Element, Link } from "react-scroll";
import image1 from "../../image/Untitled-1.jpg";
import image2 from "../../image/Asset 2.png";
import T89_1 from "../../image/T89/0T89-038J-A-V1-Approved Mass (1).jpg";
import T89_2 from "../../image/T89/0T89-038J-A-V1-Approved Mass (2).jpg";
import T89_5 from "../../image/T89/0T89-038J-A-V1-Approved Mass (5).jpg";
import SA183_1 from "../../image/SA183/1Ysr-R03-003-Media-SA183-ريماس (1).jpg";
import SA183_5 from "../../image/SA183/1Ysr-R03-003-Media-SA183-ريماس (5).jpg";
import SA183_6 from "../../image/SA183/1Ysr-R03-003-Media-SA183-ريماس (6).jpg";
import SA183_10 from "../../image/SA183/1Ysr-R03-003-Media-SA183-ريماس (10).jpg";
import SA181_2 from "../../image/SA181/1Ysr-R03-003-Media-SA181-فلوريت (2).jpg";
import SA181_16 from "../../image/SA181/1Ysr-R03-003-Media-SA181-فلوريت (16).jpg";
import SA181_18 from "../../image/SA181/1Ysr-R03-003-Media-SA181-فلوريت (18).jpg";
import S176_1 from "../../image/S176/(1).jpg";
import S176_2 from "../../image/S176/(2).jpg";
import F76_2 from "../../image/1F76/1Ysr-R03-003-Media-1F76-رونق بردى (2).jpg";
import F76_5 from "../../image/1F76/1Ysr-R03-003-Media-1F76-رونق بردى (5).jpg";
import F76_9 from "../../image/1F76/1Ysr-R03-003-Media-1F76-رونق بردى (9).jpg";
import A29 from "../../image/1A29/1A29-057S-A-View4.jpg";
import { useEffect } from "react";
import "aos/dist/aos.css";
import Aos from "aos";

const Skills = () => {
  const [indexLi, setIndexLi] = useState(0);

  const [data, setdata] = useState([
    {
      id: 3,
      title: "T89 - برج بروكار",
      bottun: " التفاصيل",
      image: T89_5,
      DetalisProjectimage5: T89_1,
      DetalisProjectimage2: T89_2,
      site: `يقع شرق الحديقة المركزية وشمال الساحة الرئيسية لمدينة ماروتا سيتي`,
      Composed: `تتألف من خمس أقبية و ثمانية عشر طابق سكني مع تواجد طوابق تقنية لخدمة البرج `,
      Marked_by: `يتميز عن باقي المقاسم بموقعه  الفريد ,اذ تُمكن واجهته من الانفتاح على الجهات الثلاثة سوياً . فهو يطل جنوباً على الساحة الرئيسية (طريق المراسم) من الجهة الشرقية , وللحديقة المركزية الواسعة حصة وافرة من الواجهة الغربية , أما عن الواجهة الشمالية فيطل على البرج T90 . `,
      Consists_of: `يتألف البرج من خمس أقبية تحتوي على خدمات متنوعة و طابقين تقني وطابقين تجاري . بالإضافة الى مرأب يضم 151 مصف . و 66 شقة و 7 مكاتب , بإضافة الى الكثير من الميزات الترفيهية  .`,
      Services: `- أنظمة التكييف 
      - أنظمة التدفئة 
      - مرآب للسيارات 
      - نوازل للقمامة 
      - طاقة شمسية و كهربائية و مائية 
      - مسابح ومرافقه 
  
      والعديد من الأنظمة التي تضمن حياة الرفاهية لكل القاطنين في البرج`,
    },
    {
      id: 7,
      title: "SA183 - برج ريماس",
      bottun: " التفاصيل",
      image: SA183_10,
      DetalisProjectimage5: SA183_5,
      DetalisProjectimage2: SA183_1,
      site: "تقع هذه الفئة في الجنوب الشرقي لمدينة ماروتا سيتي على حدود مع مدينة تنظيم كفرسوسة",
      Composed: `تتألف من ثالث أقبية وستة عشر طابق سكني مع إمكانية تواجد طوابق تقنية لخدمة البرج `,
      Marked_by: `ما يميز البرج SA183 هو الموقع الاستراتيجي في مدينة ماروتا سيتي , حيث انه يملك واجهتين رئيسيتين على تقاطع طرقي هام , يطل البرج من جهة الشرق على المقسم SA184 ومن الشمال يملك البرج إطلالة على عدة مقاسم مهيئة على ان تكون مدارس .`,
      Consists_of: `يتألف البرج من ثلاث أقبية تحتوي على خدمات متنوعة ومرآب للسيارات ومستودعات . طابق أرضي يحوي صالة ألعاب أطفال وصالة متعددة الاستخدامات . وستة عشر طابقاً سكنياً بمساحات واتجاهات مختلفة لتنوع الخيارات أمام القاطنين طابقين تقنيين لخدمة المبنى بشكل كامل .`,
      Services: `- أنظمة التكييف 
      - أنظمة التدفئة 
      - أنظمة الغاز المسيل 
      - مرآب للسيارات 
      - نوازل للقمامة 
      - طاقة شمسية  
  
      والعديد من الأنظمة التي تضمن حياة الرفاهية لكل القاطنين في البرج`,
    },
    {
      id: 8,
      title: "QA215 - برج الحرير",
      bottun: " التفاصيل",
      image: require("../../image/QA215/1Ysr-0QA215-02.jpg"),
      DetalisProjectimage5: require("../../image/QA215/1Ysr-0QA215-03.jpg"),
      DetalisProjectimage2: require("../../image/QA215/1Ysr-0QA215-04.jpg"),
      site: `يقع برج QA215 في الجهة الجنوبية الشرقية من مخطط ماروتا، مما يمنح الواجهة الجنوبية أهمية كبيرة نظرًا لعدم وجود كتل تحجب الرؤية وأشعة الشمس.`,
      Composed: ``,
      Marked_by: `يتميز البرج بموقعه الاستراتيجي حيث يتضمن مكاتباً استشارية وخدمية، مما يجعله مثاليًا لتوظيفه كمكاتب وشقق فندقية. كما يمكن استخدامه كسكن مؤقت للعاملين في المكاتب المحيطة أو للعملاء المستثمرين.`,
      Consists_of: `تم تقسيم الكتلة البرجية إلى قسمين، حيث تضم المكاتب الاستثمارية على الواجهة الشمالية، بينما تم تخصيص القسم الذي يشغل الواجهات الجنوبية والشرقية والغربية كشقق فندقية. وتم تخصيص الطابق الأرضي كصالة مناسبات وصالات عرض متعددة الاستعمالات.
      وتمت معالجة نقاط التقاء كتلة البرج مع الطابق الأرضي بشكل معماري يحولها لنقاط قوة تخدم المشروع، مع التركيز على تحسين نقطة دخول المشروع وإضافة قوة مضافة للمدخل. وتمت معالجة نقاط الالتقاء بباقي الواجهات بتراجع بسيط بكتلة البرج يسمح بخلق تراسات فوق الأرضي ونم استغلالها لتراسات المطعم والكافتريا.`,
    },
    {
      id: 9,
      title: "SA181 - فلوريت",
      bottun: " التفاصيل",
      image: SA181_2,
      DetalisProjectimage5: SA181_16,
      DetalisProjectimage2: SA181_18,
      site: "تقع هذه الفئة في الجنوب الشرقي لمدينة ماروتا سيتي على حدود مع مدينة تنظيم كفرسوسة",
      Composed: `تتألف من ثالث أقبية وستة عشر طابق سكني مع إمكانية تواجد طوابق تقنية لخدمة البرج `,
      Marked_by: `تمتلك الواجهة الرئيسية في المقسم SA181 إطلالة على شارع رئيسي في مدينة ماروتا سيتي ,
      يطل البرج من الجهة الغربية والشرقية على ابراج من فئة  ال SA ,
      أما عن الجنوب يطل البرج على مقاسم ال H التي تتألف من 12 طابق .`,
      Consists_of: `يتألف البرج من ثالثة أقبية تحتوي على خدمات متنوعة ومستودعات ومرآب للسيارت . طابق أرضي يحوي صالة أطفال وصالة متعددة االستخدامات . وستة عشر طابق سكني بمساحات واتجاهات متغايرة، بمجموع عدد شقق يساوي 53 . 
      طابقين تقنين لخدمة المبنى `,
      Services: `- أنظمة التكييف 
      - أنظمة التدفئة 
      - أنظمة الغاز المسيل 
      - مرآب للسيارات 
      - نوازل للقمامة 
      - طاقة شمسية  
  
      والعديد من الأنظمة التي تضمن حياة الرفاهية لكل القاطنين في البرج`,
    },
    {
      id: 12,
      title: "S176 - الرونق",
      bottun: " التفاصيل",
      image: S176_1,
      DetalisProjectimage5: S176_2,
      DetalisProjectimage2: S176_1,
    },
    {
      id: 15,
      title: "1F76 - رونق بردى",
      bottun: " التفاصيل",
      image: F76_5,
      DetalisProjectimage5: F76_2,
      DetalisProjectimage2: F76_9,
    },
    {
      id: 17,
      title: "1F60 - مجمع شبعا",
      bottun: " التفاصيل",
      image: image1,
      DetalisProjectimage5: image1,
      DetalisProjectimage2: image1,
    },
    {
      id: 18,
      title: "1A29 - آل كريم وعاجي",
      bottun: " التفاصيل",
      image: A29,
      DetalisProjectimage5: A29,
      DetalisProjectimage2: A29,
    },
  ]);

  const [headerfilter, setheaderfilter] = useState("جميع الابراج");
  const handleActiveLi = (e, LI) => {
    setheaderfilter(LI);
    setIndexLi(e);
  };

  useEffect(() => {
    Aos.init({ duration: 500 });
  }, []);

  return (
    <Element name="Skills">
      <section className="Skills">
        <div className="Skills-left">
          <div className="box">
            <h2
              data-aos="fade-left"
              data-aos-duration="1000"
              data-aos-easing="ease-in-out"
              className="heading"
            >
              استراتيجتنا في التطوير
            </h2>
            <p
              data-aos="fade-left"
              data-aos-duration="1500"
              data-aos-easing="ease-in-out"
            >
              في اليسر للارتقاء العمراني نقدم استراتيجية متكاملة للتطوير العقاري
              تحوّل الأفكار إلى استثمارات ناجحة. نبدأ برحلة منهجية تبدأ بدراسة
              السوق وتحليل الجدوى لاختيار الموقع الأمثل. ثم ننتقل إلى مرحلة
              التصميم المتكامل والابتكاري، لننطلق بعدها إلى التنفيذ بأعلى معايير
              الجودة والدقة. لا نتوقف عند التسليم، بل نكمل الرحلة باستراتيجيات
              تسويقية مبتكرة وخدمات إدارة متكاملة لضمان أقصى عائد استثماري
              واستدامة النجاح. نعمل لبناء ثقتك وبناء مستقبلك.
            </p>
          </div>
          <div className="box">
            <h2
              data-aos="fade-left"
              data-aos-duration="1000"
              data-aos-easing="ease-in-out"
              className="heading"
            >
              ادارتنا للمشروع
            </h2>
            <p
              data-aos="fade-left"
              data-aos-duration="1500"
              data-aos-easing="ease-in-out"
            >
              نقود مشروعك في "اليسر" بمنهجية متكاملة تبدأ بالتخطيط الاستراتيجي
              ودراسة الجدوى، مروراً بالتصميم الدقيق والتنفيذ تحت إشراف مباشر.
              نركز على إدارة الجودة والوقت والميزانية بدقة، مع التواصل المستمر
              ومراقبة الأداء. نضمن تسليم المشروع وفق أعلى المعايير، مع متابعة ما
              بعد التسليم لتحقيق القيمة المستدامة. تضمن تحويل رؤيتك إلى واقع
              ناجح.
            </p>
          </div>
          <div className="show-project">
            <ul>
              {[
                "جميع الابراج",
                "T89 - برج بروكار",
                "SA183 - برج ريماس",
                "QA215 - برج الحرير",
                "SA181 - فلوريت",
                "S176 - الحواريين",
                "1F76 - رونق بردى",
                "1F60 - مجمع شبعا",
                "1A29 - آل كريم وعاجي",
              ].map((LI, index) => (
                <li
                  key={index}
                  className={`${indexLi === index && "active"}`}
                  onClick={() => handleActiveLi(index, LI)}
                >
                  {LI}
                </li>
              ))}
            </ul>
            <div className="card-project">
              <div className="card-container">
                {data
                  .filter((val) => {
                    return headerfilter === "جميع الابراج"
                      ? val
                      : headerfilter === val.title;
                  })
                  .map((item) => (
                    <article className="card-article" key={item.id}>
                      <div className="card-image-container">
                        <img
                          src={item.image}
                          alt={item.title}
                          className="card-image"
                        />
                        <div className="card-overlay"></div>
                      </div>
                      <div className="card-data">
                        <h2 className="card-title">{item.title}</h2>
                        <NavLink
                          to="/detalis"
                          state={{
                            data: item,
                          }}
                          className="card-button"
                        >
                          {item.bottun}
                          <i className="bx bx-chevron-left"></i>
                        </NavLink>
                      </div>
                    </article>
                  ))}
              </div>
            </div>
          </div>
        </div>
        <div className="Skills-right">
          <p>03</p>
          <span></span>
          <label>المشاريع</label>
        </div>
      </section>
    </Element>
  );
};

export default Skills;
